<template>
	<div class="section">
		<div class="container is-large">
			<WidgetOverview />
			<div class="section-body">
				<div class="body-item-left">
					<WidgetHistory />
				</div>
				<div class="body-item-right">
					<WidgetCreate />
					<WidgetLinkDetails />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import WidgetOverview from '@/components/WidgetOverview.vue';
import WidgetHistory from '@/components/WidgetHistory.vue';
import WidgetCreate from '@/components/WidgetCreate.vue';
import WidgetLinkDetails from '@/components/WidgetLinkDetails.vue';
import { mapActions } from 'vuex';

export default {
	name: 'Dashboard',
	components: {
		WidgetOverview,
		WidgetHistory,
		WidgetCreate,
		WidgetLinkDetails,
	},

	mounted() {
		this.fetchCountries();
	},

	methods: {
		...mapActions(['fetchCountries']),
	},
};
</script>

<style lang="scss" scoped>
.section {
	position: relative;
	background-color: $color-black;
	color: $color-white;

	.section-body {
		display: flex;
		flex-wrap: wrap;
		padding: $gap-4 $gap-5 $gap-2 $gap-5;

		.body-item-left {
			width: 33%;
			overflow: hidden;
		}

		.body-item-right {
			width: 67%;
		}
	}
}
</style>
